import * as types from './types';

export const startBlock = () => {
	return { type: types.REQUEST_START };
};

export const stopBlock = () => {
	return { type: types.REQUEST_SUCCESS };
};
